// eslint-disable-next-line
import Worker from "comlink-loader!./occupancyWorker"; // inline loader

export default Worker;
